import { useImmatWheels } from '@amo/core/api/wheels.js';
import motards from '@amo/core/assets/images/AMO_Icons/Tout-motards.svg';
import { Question } from '@amo/core/components/containers';
import { Radio, Text } from '@amo/core/components/forms/index.js';
import { minLentghImmatriculation, required, validateImmatriculation } from '@amo/core/utils';
import moment from 'moment/moment.js';
import { useState } from 'react';
import { Field } from 'redux-form';
import Swal from 'sweetalert2';

export const SearchByImmat = (props) => {
    const { nextQuestion, data, changeValue, setVehicule } = props;
    const validImmat = !minLentghImmatriculation(data?.searchImmat) && !validateImmatriculation(data?.searchImmat) && !!data?.searchImmat;
    const [canGoNext, setCanGoNext] = useState(false);
    const [a2filter, setA2filter] = useState("1");
    const { data: responseVehicles, isLoading, isFetched } = useImmatWheels(validImmat, data?.typeVehicule, data?.searchImmat, a2filter);

    const dataVehicles = responseVehicles?.data?.vehicles ?? [];
    const dataFiltered = responseVehicles?.data?.filtered ?? false;

    const refreshSearch = () => {
        setA2filter("0");
    };

    const setSelectedVehicle = (vehicle) => {
        changeValue('searchBy', 'immatriculation');
        setVehicule({data: vehicle})

        if (vehicle.souscription_disabled) {
            Swal.fire({
                icon: 'warning',
                iconHtml: '<span class="warning"></span>',
                title: 'Oups... Erreur de trajectoire',
                text: 'Malheureusement, nous ne pouvons pas vous proposer d’assurance pour ce type de véhicule. Vous pouvez reprendre votre demande de devis en modifiant votre réponse.',
                showConfirmButton: true,
                confirmButtonText: 'Terminer',
                showCloseButton: true,
            });
            setCanGoNext(false);
        } else {
            changeValue(`code_categorie`, vehicle.codecategorie);
            changeValue(`cylindreeVehicule`, vehicle.cylindree);
            changeValue('DemandeTarif[Vehicule][IdentifiantSRA]', vehicle.sra);
            changeValue('DemandeTarif[Vehicule][DateMEC]', moment(responseVehicles?.data.date_premiere_immat, 'YYYY-MM-DD').format('DD/MM/YYYY'));
            changeValue('DemandeTarif[Vehicule][ValeurVehicule]', vehicle.prix_origine);
            changeValue('DemandeTarif[Vehicule][Immatriculation]', data?.searchImmat);
            changeValue('typeVehicule', vehicle.type.id);
            setCanGoNext(true);
        }
    };

    return (
        <Question asFieldset icon={motards} title={`Je recherche <b>mon véhicule</b> :`} bandeau {...props} >
            <div className={'row flex-column justify-content-center align-content-center mt-2'}>
                <div className={'col-lg-8  my-2 d-flex flex-column'} role="search" aria-label="Recherche par immatriculation">
                    <Field
                        name={`searchImmat`}
                        label={"N° d'immatriculation du véhicule"}
                        placeholder={'EX: AA 123 BB'}
                        component={Text}
                        type={'text'}
                        typeFormat={'immat'}
                        validate={[minLentghImmatriculation, validateImmatriculation]}
                        required={required}
                    />

                    {isLoading && <span className="mt-2 mx-auto d-block spinner-border spinner-border-sm" role="status"
                                        aria-label="Chargement en cours"/>}

                    {dataVehicles.length > 0 && isFetched ? (
                        <div className="mt-4">
                            {dataVehicles.map((vehicle, index) => (
                                <Field
                                    key={vehicle.sra}
                                    type={'radio'}
                                    className={`small option w-full`}
                                    label={`${vehicle.brand.name} ${vehicle.modele} ${vehicle.version}`}
                                    icon={vehicle.brand.img}
                                    value={vehicle.sra}
                                    description={`${vehicle.annee_debut_version !== null && vehicle.annee_debut_version !== 0 ? `depuis ${vehicle.annee_debut_version}` : ''} ${vehicle.annee_fin_version !== null && vehicle.annee_fin_version !== 0 ? ` jusqu'à ${vehicle.annee_fin_version}` : ''} ${vehicle.annee_fin_version || vehicle.annee_debut_version ? '-' : ''} ${vehicle.cylindree} cm3`}
                                    name={'selectVehicle'}
                                    onChange={(e) => setSelectedVehicle(vehicle)}
                                    component={Radio}
                                    validate={required}
                                />
                            ))}
                        </div>
                    ) : isFetched && validImmat ? (
                        <div className={'alert-danger alert mt-1 mb-0'}>
                            Aucun modèle n'a été trouvé avec votre immatriculation.
                        </div>
                    ) : null}
                    {
                        dataFiltered &&
                        <span className="d-block text-secondary f-13 mt-1">
                            <button type="button" className="underline-link cursor-pointer bg-transparent border-0 p-0 text-secondary f-13" onClick={refreshSearch}>Voir d'autres versions (A2, modèle...) pour ce véhicule</button>
                        </span>
                    }
                </div>
            </div>

            <div className="d-flex flex-column align-items-center mt-4">
                <button className={`btn btn-primary btn-arrow  ${!canGoNext && 'disabled'}`} onClick={() => nextQuestion()}>
                    Continuer
                </button>

                <button
                    type="button"
                    className={`mt-4 bg-transparent border-0 p-0`}
                    style={{ cursor: 'pointer', textDecoration: 'underline' }}
                    onClick={() => {
                        changeValue('searchBy', 'modele');
                    }}
                >
                    Je préfère rechercher par marque et modèle.
                </button>
            </div>
        </Question>
    );
};
